// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-PUZ7","name":"styles_name__2bgt3","phone":"styles_phone__1hupg"};